'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ListTypeCover = require('./components/ListTypeCover.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListTypeCover).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/list-type-cover/index.js
// module id = 1045
// module chunks = 0